import type { MpApprovalRow } from '../types/marketPromotion.types';
import { DecisionTrailPanel, type DecisionStep } from './DecisionTrailPanel';

const TRAIL_SKELETON_ROW_COUNT = 4;

function getDecisionSteps(donation: MpApprovalRow, isMisQueue: boolean): DecisionStep[] {
  const steps: DecisionStep[] = [
    {
      key: 'entered',
      step: 'Entered',
      isDone: true,
      by: donation.enteredByName,
      at: donation.enteredAt,
      comment: donation.recordComments,
    },
    {
      key: 'recommendation',
      step: 'Recommendation',
      isDone: donation.recommendedBy !== null,
      by: donation.recommendedBy,
      at: donation.recommendedAt,
      comment: donation.recommendedComments,
    },
    {
      key: 'approval',
      step: 'Approval',
      isDone: donation.approvedBy !== null,
      by: donation.approvedBy,
      at: donation.approvedAt,
      comment: donation.approvalComments,
    },
  ];

  if (isMisQueue) {
    steps.push({
      key: 'misCall',
      step: 'MIS Call',
      isDone: donation.calledBy !== null,
      by: donation.calledBy,
      at: donation.callTime,
      comment: donation.misComment,
    });
  }

  return steps;
}

interface DonationDecisionTrailProps {
  donation: MpApprovalRow | undefined;
  isMisQueue: boolean;
}

export function DonationDecisionTrail({ donation, isMisQueue }: DonationDecisionTrailProps) {
  return (
    <DecisionTrailPanel
      title="Decision Logs"
      steps={donation ? getDecisionSteps(donation, isMisQueue) : undefined}
      skeletonRowCount={TRAIL_SKELETON_ROW_COUNT}
    />
  );
}
